import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AutoUnsubscribe} from "@decorators/auto-unsubscribe";
import {NgxPopupComponent} from "@components/shared/ngx-popups/ngx-popups/components/popup.component";
import {Observable, Subscription} from "rxjs";
import {finalize} from "rxjs/operators";
import { ChangeLogService } from '@services/change-log.service';
import { Logger, LoggingService } from '@services/logging.service';
import { ChangeLogEntry } from '@models/change-log-entry';
import { CallTypeCategory } from '@utils/enums';

@AutoUnsubscribe('subsArr$')
@Component({
    selector: 'app-change-log-modal',
    templateUrl: './change-log-modal.component.html',
    styleUrls: ['./change-log-modal.component.scss'],
    standalone: false
})
export class ChangeLogModalComponent implements OnInit {
  @Input() popup: NgxPopupComponent; // MANDATORY
  @Input() companyId: number;
  @Input() analysisId: number | null;
  @Input() callTypeCategory: CallTypeCategory;

  @Output() callback = new EventEmitter<boolean>();
  subsArr$: Subscription[] = [];
  showSpinner: boolean = false;
  changeLogs: ChangeLogEntry[] = [];
  helperText = 'History of any changes to analysis.';

  HEADER_TEXT = 'CHANGE LOG';

  private logger: Logger;

  constructor(
    public changeLogService: ChangeLogService,
    private _loggingService: LoggingService,
  ) {
    this.logger = this._loggingService.rootLogger.newLogger('ChangeLogModalComponent');
  }

  ngOnInit(): void {
    const logData = this.retrieveLogData();

    if (!logData) {
      this.logger.error('Change log modal opened with an unsupported call type category.', {
        callTypeCategory: this.callTypeCategory,
      });
      this.closeModal();
      return;
    }

    this.showSpinner = true;
    this.subsArr$.push(logData
      .pipe(
        finalize(() => {
          this.showSpinner = false;
        }))
      .subscribe(results => {
        this.changeLogs = results;
      }, error => {
        this.logger.error('Failed to load the analysis change log.', { errorObject: error });
        this.closeModal();
      }));
  }

  closeModal() {
    this.callback.emit(false);
    this.popup.close();
  }

  retrieveLogData(): Observable<ChangeLogEntry[]> {
    if (this.callTypeCategory === CallTypeCategory.SingleEntityAnalysis) {
      return this.changeLogService.loadSingleEntityAnalysisChangeLogForCompany(this.companyId, this.analysisId);
    } else if (this.callTypeCategory === CallTypeCategory.MultiEntityAnalysis) {
      return this.changeLogService.loadMultiEntityAnalysisChangeLogForCompany(this.companyId, this.analysisId);
    }
    return null;
  }
}
